import { useEffect } from 'react';
import { currentAppEnv, envTitlePrefix } from './appEnv';

// Every tab is "The Sweet Spot - <Area>", with deeper pages nesting
// segments ("Inventory/Inventory Counts/Start a Shelf Count"). Pages with no
// specific title (login, error states) fall back to the bare site name. Dev and
// stage tabs start with "DEV · " or "STAGE · " so they cannot be mistaken for prod.
const SITE_TITLE = 'The Sweet Spot';

export function useDocumentTitle(segments?: string[]): void {
  const path = segments?.filter(Boolean).join('/') || undefined;
  useEffect(() => {
    const title = path ? `${SITE_TITLE} - ${path}` : SITE_TITLE;
    document.title = `${envTitlePrefix(currentAppEnv())}${title}`;
  }, [path]);
}
